<template>
  <b-button :variant="variant" :type="type" :disabled="disabled" @click="handleClick($event)"
    :class="`min-width-icon ${customClass}`" :size="size">
    <slot></slot>
  </b-button>
</template>

<script>

export default {
  name: 'BaseButton',
  props: {
    minWidth: {
      type: String,
      default: '27px',
    },
    variant: {
      type: String,
      default: '',
    },
    size: { type: String, default: 'sm' },
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped>
.min-width-icon {
  min-width: v-bind(minWidth);
}

/* Add any custom styles here */
</style>
